export function apiRequestActions(name: string) {
  return {
    success: `${name}_SUCCESS`,
    error: `${name}_ERROR`,
    pending: `${name}_PENDING`
  };
}
